import { FlexBox } from '@airship-platform/jam-web/components';
import CircularProgress from '@mui/material/CircularProgress';
import Menu from '@mui/material/Menu';
import { useState } from 'react';
import { useProposalQualityScore } from '../../../data-access/proposalQualityScore';
import CircularScoreIndicator from './CircularScoreIndicator';
import ProposalScoreMenuContent from './ProposalScoreMenuContent';

const ProposalScoreIndicator: React.FC = () => {
  const { qualityScore, isLoading } = useProposalQualityScore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isLoading) {
    return <CircularProgress size={27} />;
  }

  if (!qualityScore) return null;

  return (
    <>
      <FlexBox onClick={handleClick} sx={{ cursor: 'pointer' }}>
        <CircularScoreIndicator score={qualityScore.score} />
      </FlexBox>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: { minWidth: 320, maxWidth: 360 },
          },
        }}
      >
        <ProposalScoreMenuContent data={qualityScore} onClose={handleClose} />
      </Menu>
    </>
  );
};

export default ProposalScoreIndicator;
